/*
 *
 * OperationDetailModal
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 06-Dec-2024
 */

import React from 'react'
import PropTypes from 'prop-types'
import MerchantModal from '@nexidigital/merchantmodal'
import OperationDetail from 'Components/OperationDetail'
import formattedMessage from './languageModule'
import './OperationDetailModal.scss'

const OperationDetailModal = ({ data, actions }) => {
  const { operationId } = data
  return (
    <MerchantModal
      bigPopup
      withoutButton
      topBarTitle={formattedMessage.operation(operationId)}
      onClose={() => actions.closePopup()}>
      <OperationDetail id={operationId} />
    </MerchantModal>
  )
}

OperationDetailModal.propTypes = {
  data: PropTypes.shape({
    operationId: PropTypes.string
  }),
  actions: PropTypes.object
}

OperationDetailModal.defaultProps = {
  data: {},
  actions: {}
}

export default OperationDetailModal
